// Need to use the React-specific entry point to import createApi

import { baseApi } from "./baseApi";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const settingApi = baseApi.injectEndpoints({
  reducerPath: "settingApi",

  // mode: "no-cors",
  // credentials: "include",
  endpoints: (builder) => ({
    changePassword: builder.mutation({
      query: (data) => {
        return {
          url: "change-password",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    addOrUpdateStaticPages: builder.mutation({
      query: ({ data, slug }) => {
        return {
          url: `page/${slug}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      invalidatesTags: ["Static"],
    }),
    getStaticPages: builder.query({
      query: () => {
        return {
          url: "page",
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["Static"],
    }),
    getAppSettings: builder.query({
      query: () => {
        return {
          // url: "setting",
          url: "setting",
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["Static"],
    }),
    updateAppSettings: builder.mutation({
      query: (data) => {
        return {
          url: "setting/1",
          method: "PATCH",
          body: data,
          headers: {
            // "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getProfile: builder.query({
      query: () => {
        return {
          url: "",
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["Static"],
    }),
    updateProfile: builder.mutation({
      query: (data) => {
        return {
          url: "",
          method: "PATCH",
          body: data,
          headers: {
            // "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useChangePasswordMutation,
  useAddOrUpdateStaticPagesMutation,
  useGetStaticPagesQuery,
  useGetAppSettingsQuery,
  useUpdateAppSettingsMutation,
  useGetProfileQuery,
  useUpdateProfileMutation,
} = settingApi;
